import React from 'react'

import classes from "./underline.module.scss";

const Underline = (props) => {
    let classesArray = [classes.Line];
    if(props.size === "small") {
        classesArray.push(classes.Small);
    }
    
    return (  
        <div className={classesArray.join(' ')}></div>
    );
}
 
export default Underline;